import ApiClient from '@package/services/src/ApiClient';
import Result from '@package/services/src/Result';

import { PaymentMethodsService } from './services';
import { GetPaymentMethodsRequest, PaymentMethods } from './types';

export default class PaymentMethodsApiService implements PaymentMethodsService {
  public constructor(private readonly apiClient: ApiClient) {}

  public async getPaymentMethods(request?: GetPaymentMethodsRequest): Promise<Result<Array<PaymentMethods>>> {
    try {
      const res = await this.apiClient.get('shoppingCart/paymentMethods', {
        headers: request?.cookie ? { Cookie: request.cookie } : undefined,
      });
      const json = await res.json();

      return new Result(json);
    } catch (error) {
      return new Result([]);
    }
  }

  public async getShoppingCartPaymentMethods(
    request?: GetPaymentMethodsRequest,
  ): Promise<Result<Array<PaymentMethods>>> {
    try {
      const res = await this.apiClient.get('shoppingCart/cartPaymentMethods', {
        headers: request?.cookie ? { Cookie: request.cookie } : undefined,
      });
      const json = await res.json();
      return new Result(json);
    } catch (error) {
      return new Result([]);
    }
  }
}
